import React, { useEffect, useState } from "react"

// Components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout"
import { AdminHeader } from "shared/components/common/AdminHeader"
import DashboardNavbar from "examples/Navbars/DashboardNavbar"
import MDSnackbar from "components/MDSnackbar"

import MDBox from "components/MDBox"
import { Loading } from "shared/components/ui/Loading"
import MDTypography from "components/MDTypography"
import LeaveRequestBasicInformation from "components/LeaveRequestBasicInformation/LeaveRequestBasicInformation"
import TeacherLeaveHistory from "components/TeacherLeaveHistory/TeacherLeaveHistory"
import {
  useApproveLeaveRequestAdminMutation,
  useLazyGetLeaveAwareDetailQuery,
  useRejectLeaveRequestAdminMutation,
} from "shared/redux/endpoints/employee"
import { useNavigate, useParams } from "react-router-dom"
import LeaveRelatedInfomationContent from "components/LeaveRelatedInfomationContent/LeaveRelatedInfomationContent"
import { Button, Divider } from "@mui/material"
import ModalApproveLeave from "components/ModalApproveLeave/ModalApproveLeave"
import ModalReasonDenyLeave from "components/ModalReasonDenyLeave/ModalReasonDenyLeave"

export const LeaveRequestDetail = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(true)
  const [detail, setDetail] = useState(null)
  const [awareInfo, setAwareInfo] = useState(null)
  const [triggerGetDetail] = useLazyGetLeaveAwareDetailQuery()
  const [approveLeaveRequest] = useApproveLeaveRequestAdminMutation()
  const [rejectLeaveRequest] = useRejectLeaveRequestAdminMutation()
  const [openModalApproveLeave, setOpenModalApproveLeave] = useState(false)
  const [openModalReasonDenyLeave, setOpenModalReasonDenyLeave] =
    useState(false)
  const [openSnackbar, setOpenSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  })

  const fetchDetail = async (requestId) => {
    setIsLoading(true)
    await triggerGetDetail(requestId)
      .then((res) => {
        setDetail(res?.data?.data?.leaveRequest ?? null)
        setAwareInfo(res?.data?.data?.awareInfo ?? null)
      })
      .finally(() => setIsLoading(false))
  }

  useEffect(() => {
    if (!id) return
    fetchDetail(id)
  }, [id])

  const propsModalApproveLeave = {
    isOpen: openModalApproveLeave,
    onClose: () => setOpenModalApproveLeave(false),
    onSubmit: async () => {
      if (detail?.leaveRequestId) {
        await approveLeaveRequest(detail.leaveRequestId).then((result) => {
          if (result?.error) {
            setOpenSnackbar({
              open: true,
              message:
                result?.error?.data?.data?.message ||
                "Failed to approve leave request",
              severity: "error",
            })
          } else {
            setOpenSnackbar({
              open: true,
              message: "Leave request approved successfully",
              severity: "success",
            })
            navigate("/leave-request/list")
          }
        })
      }
      setOpenModalApproveLeave(false)
    },
  }

  const propsModalReasonDenyLeave = {
    isOpen: openModalReasonDenyLeave,
    onClose: () => setOpenModalReasonDenyLeave(false),
    onSubmit: async (reason) => {
      if (detail?.leaveRequestId) {
        await rejectLeaveRequest({
          id: detail.leaveRequestId,
          rejectionReason: reason,
        }).then((result) => {
          if (result?.error) {
            setOpenSnackbar({
              open: true,
              message:
                result?.error?.data?.data?.message ||
                "Failed to reject leave request",
              severity: "error",
            })
          } else {
            setOpenSnackbar({
              open: true,
              message: "Leave request rejected successfully",
              severity: "success",
            })
            navigate("/leave-request/list")
          }
        })
      }
      setOpenModalReasonDenyLeave(false)
    },
  }

  return (
    <DashboardLayout>
      <AdminHeader />
      <DashboardNavbar light />
      <MDBox className="container-lxo-task">
        <MDBox className="header-lxo-task">
          <MDBox className="group-title">
            <MDTypography className="title">Leave request detail</MDTypography>
          </MDBox>
        </MDBox>
        <Divider sx={{ borderBottomStyle: "dashed", width: "100%" }} />
        {isLoading ? (
          <Loading style={{ width: 250, height: 200, margin: "150px auto" }} />
        ) : (
          <>
            <LeaveRequestBasicInformation data={detail} />
            {/* <Divider
              sx={{
                mt: 1.5,
                mb: 0,
                borderBottomStyle: "dashed",
                width: "100%",
              }}
            />
            <TeacherLeaveHistory
              remainingLeaveDays={detail?.remainingLeaveDays}
              totalLeaveDaysTaken={detail?.totalLeaveDaysTaken}
              mostRecent={{
                startDate: detail?.startDate,
                endDate: detail?.endDate,
                status: detail?.status,
              }}
            /> */}
            <Divider
              sx={{
                mt: 1.5,
                mb: 0,
                borderBottomStyle: "dashed",
                width: "100%",
              }}
            />
            <LeaveRelatedInfomationContent awareInfo={awareInfo} />
          </>
        )}

        <MDBox
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: 1.5,
            mt: 3,
            marginLeft: "auto",
          }}
        >
          {detail?.status === "APPROVED" || detail?.status === "REJECTED" ? (
            <Button
              variant="contained"
              onClick={() => navigate("/leave-request/list")}
              sx={{
                minWidth: 78,
                height: 36,
                px: 2,
                textTransform: "none",
                fontSize: "12px",
                fontWeight: 600,
                borderRadius: "6px",
                backgroundColor: "#fff",
                boxShadow: "none",
                color: "#333",
                border: "1px solid #ccc",
                "&:hover": {
                  backgroundColor: "#fff",
                  boxShadow: "none",
                },
              }}
            >
              Back
            </Button>
          ) : (
            <>
              <Button
                variant="contained"
                onClick={(e) => {
                  e.preventDefault()
                  setOpenModalReasonDenyLeave(true)
                }}
                sx={{
                  minWidth: 70,
                  height: 36,
                  px: 2,
                  textTransform: "none",
                  fontSize: "12px",
                  fontWeight: 600,
                  borderRadius: "6px",
                  backgroundColor: "#ff4d4f",
                  boxShadow: "none",
                  color: "#fff",
                  "&:hover": {
                    backgroundColor: "#e53935",
                    boxShadow: "none",
                  },
                }}
              >
                Deny
              </Button>

              <Button
                variant="contained"
                onClick={() => setOpenModalApproveLeave(true)}
                sx={{
                  minWidth: 78,
                  height: 36,
                  px: 2,
                  textTransform: "none",
                  fontSize: "12px",
                  fontWeight: 600,
                  borderRadius: "6px",
                  backgroundColor: "#52c41a",
                  boxShadow: "none",
                  color: "#fff",
                  "&:hover": {
                    backgroundColor: "#389e0d",
                    boxShadow: "none",
                  },
                }}
              >
                Approve
              </Button>
            </>
          )}
        </MDBox>
      </MDBox>
      <ModalApproveLeave {...propsModalApproveLeave} />
      <ModalReasonDenyLeave {...propsModalReasonDenyLeave} />

      <MDSnackbar
        color={openSnackbar.severity}
        icon="check"
        title="Notice"
        content={openSnackbar.message}
        open={openSnackbar.open}
        onClose={() => setOpenSnackbar({ ...openSnackbar, open: false })}
        close={() => setOpenSnackbar({ ...openSnackbar, open: false })}
        bgWhite
      />
    </DashboardLayout>
  )
}
